import '../css/message.css';
import React from 'react';
import PropTypes from 'prop-types';

const Message = (props) => {
  const {
    messageType, messageTitle, messageText, onClose,
  } = props;

  return (
    <div className="form-message">
      <div className="form-message_header">
        <span>{messageTitle}</span>
        <button className="form-message_close-btn button-clear" onClick={onClose} type="button">
          <svg
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 1000 1000"
            enableBackground="new 0 0 1000 1000"
            className="close-modal"
          >
            <g><path d="M500,405.9L123.6,29.5c-26-26-68-25.9-94,0.1c-25.9,25.9-26,68.1-0.1,94L405.9,500L29.5,876.4c-26,26-25.9,68,0.1,94c25.9,25.9,68.1,26,94,0.1L500,594.1l376.4,376.4c26,26,68,25.9,94-0.1c25.9-25.9,26-68.1,0.1-94L594.1,500l376.4-376.4c26-26,25.9-68-0.1-94c-25.9-25.9-68.1-26-94-0.1L500,405.9z" /></g>
          </svg>
        </button>
      </div>
      <div className={`message ${messageType}`}>{messageText}</div>
      <div className="btn-ok">
        <button type="button" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

Message.propTypes = {
  onClose: PropTypes.func.isRequired,
  messageType: PropTypes.string.isRequired,
  messageText: PropTypes.string.isRequired,
  messageTitle: PropTypes.string.isRequired,
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/Message.js